<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">

          <Loader v-if="!isLoaded"/>
          <div v-else>
            <div class="d-flex justify-content-between">
              <h6 class="element-header">
                Einzelcoaching module - zufälliger Modulziel
              </h6>
              <CreateButton
                  :label="$t('general.button.back')"
                  :to="{ name: 'coursePrivateCoachingModuleList' }">
              </CreateButton>
            </div>

            <div class="element-box mt-3">
              <div class="row text-end">
                <div class="col-12">
                  <button type="button" class="btn btn-primary" @click="handleModuleForm">
                    Zufälliger Modulziel hinzufügen
                  </button>
                </div>
              </div>

              <EmptyState
                  v-if="!randomGoals.data?.length"
                  icon="fa-bullseye"
                  title="Keine Modulziele gefunden"/>

              <div v-else class="table-responsive overflow-auto mt-5">
                <table class="table table-striped">
                  <thead>
                  <tr>
                    <th>Name</th>
                    <th style=" text-align: right; padding-right: 30px; min-width: 150px;">{{
                        $t('general.actions')
                      }}
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(goal) in randomGoals.data" :key="goal.id">
                    <td>{{ goal?.name }}</td>
                    <td class="text-end">
                      <button class="btn btn-primary"
                              @click="handleEditModuleForm(goal.id)">
                        <i class="os-icon os-icon-edit"></i>
                      </button>
                      <button class="btn btn-danger ms-2"
                              @click="handleDeleteModule(goal?.id)">
                        <i class="os-icon os-icon-trash"></i>
                      </button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Sidebar/>


      <Modal
          v-model="showFormModal"
          title="zufälliger Modulziel"
          :hide-cancel="true"
          :button-label="$t('general.button.save')"
          sizeModal="modal-xl"
          :hide-footer="true"
          classFooter="justify-content-center">
        <Form :goalId="goalId"
              v-model:submitForm="submitForm"/>
      </Modal>

      <ModalDelete
          v-model="showDeleteModal"
          :header="t('general.delete_item_header')"
          :onDelete="confirmDeleteModuleGoal">
      </ModalDelete>
    </div>
  </div>
</template>

<script setup>
import coursePrivateCoachingModuleService from '@/api/Course/PrivateCoachingModule';
import CreateButton from '@/components/CreateButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import Sidebar from '@/components/FormSidebar.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import Form from '@/views/App/Course/PrivateCoachingModule/RandomModule/Form.vue';
import { onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }           = useI18n();
const randomGoals     = ref([]);
const isLoaded        = ref(false);
const goalId          = ref(null);
const showFormModal   = ref(false);
const showDeleteModal = ref(false);
const submitForm      = ref(false);

watch(submitForm, () => {
  goalId.value          = null;
  showFormModal.value   = false;
  showDeleteModal.value = false;
  getRandomGoals();
});

async function getRandomGoals() {
  try {
    const { data }    = await coursePrivateCoachingModuleService.getRandomModuleGoals();
    randomGoals.value = data;
  } catch (error) {
    await ErrorToast(error);
  }
}

function handleModuleForm() {
  CloseToast()
  goalId.value          = null;
  showFormModal.value   = true;
  showDeleteModal.value = false;
}

function handleEditModuleForm(id) {
  CloseToast()
  goalId.value          = id;
  showFormModal.value   = true;
  showDeleteModal.value = false;
}

function handleDeleteModule(id) {
  CloseToast()
  goalId.value          = id;
  showFormModal.value   = false;
  showDeleteModal.value = true;
}

async function confirmDeleteModuleGoal() {
  try {
    showDeleteModal.value = false;

    await coursePrivateCoachingModuleService.deleteRandomModuleGoal(+goalId.value);

    await getRandomGoals();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  CloseToast()
  await getRandomGoals();

  isLoaded.value = true;
});

</script>

<style scoped>
</style>